import React, { FC } from 'react';
import { CommonApp } from '../../common/components/common-app/CommonApp';
import { ReportTimeSystemEntity } from '../../report-time-system/ReportTimeSystemEntity';
import { EnterpriseMain } from './EnterpriseMain';
import { EnterpriseProvider } from './EnterpriseContext';

type Props = {
  readKey: string;
};

export const EnterpriseApp: FC<Props> = ({ readKey }) => (
  <CommonApp>
    <ReportTimeSystemEntity entityType="enterprise" readKey={readKey}>
      <EnterpriseProvider>
        <EnterpriseMain />
      </EnterpriseProvider>
    </ReportTimeSystemEntity>
  </CommonApp>
);
